import { API_URL } from "../../config";

const BASE_URL = API_URL;
export const LOGIN_URL = BASE_URL + "auth/login";
export const GET_ME_URL = BASE_URL + "auth/me";
export const LOGOUT_URL = BASE_URL + "auth/logout";

export const OPERATOR_URL = BASE_URL + "operators";
export const USER_URL = BASE_URL + "users";
export const DELETE_USER_URL = `${BASE_URL}users`;

export const TICKET_UPDATE_URL = BASE_URL + "tickets/set-ticket-to-operator";
export const GET_TICKETS_BY_OPERATOR = BASE_URL + "tickets/tickets-by-operator";
export const GET_TICKETS_SEARCH = BASE_URL + "tickets/search";
export const GET_TICKET_BY_ID = BASE_URL + "tickets/by-id";
export const GET_ALL_TICKETS = BASE_URL + "tickets";
export const POST_IMAGE_URL = BASE_URL + "image";
export const POST_IMAGE_WIDGET_URL = BASE_URL + "image/operator-widget";
export const POST_OPERATOR_IMAGE_URL = BASE_URL + "image/operator";

export const GET_ALL_CLOSE_TICKET = BASE_URL + "tickets/closed";
export const FILTER_TICKETS = BASE_URL + "tickets/filter";

export const GET_ALL_MESSAGES_BY_OPERATOR_ID =
  BASE_URL + "messages/get-messages-by-operator-id";
export const GET_ALL_MESSAGES_BY_TICKET_ID =
  BASE_URL + "messages/get-messages-by-ticket-id";
export const POST_MESSAGE = BASE_URL + "users/message";

export const POST_SMS = BASE_URL + "sms";

export const GET_COMMON_STATS = BASE_URL + "tickets/common-stats/";
export const GET_OPERATOR_STATS = BASE_URL + "tickets/operator-stats/";

export const GET_ALL_OPEN_TICKET_BY_PROJECT = (project: string) =>
  `${BASE_URL}project/${project}`;

export const GET_IDENTIFICATION_API = BASE_URL + "identification/info";

export const GET_APPLICATION_API = BASE_URL + "ekhizmat/application";

export const GET_ALL_DEV_TICKETS = BASE_URL + "dev-tickets";
export const GET_DEV_TICKET_BY_ID = BASE_URL + "dev-tickets";
export const CREATE_DEV_TICKET = BASE_URL + "dev-tickets";
export const COMPLETE_DEV_TICKET = BASE_URL + "dev-tickets";
export const GET_MY_TICKETS = BASE_URL + "dev-tickets/my";
export const SEARCH_TICKETS_SHORT = BASE_URL + "tickets/search-short";

export const GET_TICKETS_BY_TELEGRAM_ID = BASE_URL + "tickets/by-telegram-id";
